import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import {Field, reduxForm, FieldArray, formValueSelector, change} from 'redux-form'

import {
  FormButtons,
  validations,
  renderers,
  upperCase,
} from '../../components'
import {connect} from "react-redux";
import {GSXService} from "../../services";

const getFormItems = (enableBulkMode) => {
  return enableBulkMode ? (
    <ReactBootstrap.Col>
      <FieldArray name="inventory_items" component={renderItems} />
    </ReactBootstrap.Col>
  ) : (
    <div>
      <ReactBootstrap.Col xs="12">
        <Field
          name="serial_number"
          type="text"
          normalize={upperCase}
          validate={[validations.required]}
          component={renderers.renderField}
          label="Serial Number"
        />
        <Field
          name="po_number"
          type="text"
          validate={[validations.required]}
          component={renderers.renderField}
          label="PO Number"
        />
        <Field
          name="awb_number"
          type="text"
          validate={[validations.required]}
          component={renderers.renderField}
          label="AWB Number"
        />
      </ReactBootstrap.Col>
    </div>
  )
}

const renderItems = ({ fields, meta: { error, submitFailed } }) => {
  if (fields.length === 0) {
    fields.push({})
  }
  return (
    <ReactBootstrap.ListGroup>
      {fields.map((member, index) => (
        <ReactBootstrap.ListGroupItem key={index}>
          <Field
            name={`${member}.serial_number`}
            type="text"
            normalize={upperCase}
            validate={[validations.required]}
            component={renderers.renderField}
            label="Serial Number"
          />
          <Field
            name={`${member}.po_number`}
            type="text"
            validate={[validations.required]}
            component={renderers.renderField}
            label="PO Number"
          />
          <Field
            name={`${member}.awb_number`}
            type="text"
            validate={[validations.required]}
            component={renderers.renderField}
            label="AWB Number"
          />
          <ReactBootstrap.Button
            style={{ float: 'right' }}
            variant="outline-dark"
            size="sm"
            title="Remove Member"
            onClick={() => fields.remove(index)}
          >
            Remove
          </ReactBootstrap.Button>
        </ReactBootstrap.ListGroupItem>
      ))}
      <ReactBootstrap.ListGroupItem>
        <ReactBootstrap.Button
          style={{ float: 'right' }}
          variant="outline-dark"
          size="sm"
          onClick={() => fields.push({})}
        >
          {' '}
          Add{' '}
        </ReactBootstrap.Button>
        {submitFailed && error && <span>{error}</span>}
      </ReactBootstrap.ListGroupItem>
    </ReactBootstrap.ListGroup>
  )
}
const FORM_NAME='repair-inventory-form'
let RepairInventoryForm = ({
  handleSubmit,
  pristine,
  reset,
  dispatch,
  submitting,
  enableBulkMode,
  consignment_type,
  rights,
  partNumber
}) => {
  function getDescription() {
    new GSXService().part_summary({search_criteria:{
      partNumbers:[partNumber]
    }}).then((res)=>{

                dispatch(
                    change(
                        FORM_NAME,
                        'description',
                        res[0].description
                    )
                )
    })
  }

  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Col xs="12">
        <Field
          component={renderers.renderSelectField}
          as="select"
          validate={[validations.required]}
          name="organization"
          label="Organization"
        >
          {rights &&
            rights
              .filter((x) => x.is_active &&  x.repair_inventory === true)
              .map((opt) => (
                <option key={opt.organization_code} value={opt.organization}>
                  {opt.organization_code}-{opt.organization_name}
                </option>
              ))}
        </Field>
        <Field
          name="part_number"
          type="text"
          normalize={upperCase}
          validate={[validations.required]}
          component={renderers.renderField}
          label="Part Number"
        />
        {partNumber && <ReactBootstrap.Button className={"float-end"} onClick={getDescription}>Get Description</ReactBootstrap.Button>}
        <br/>
        <Field
          name="description"
            disabled={true}
          type="text"
          validate={[validations.required]}
          component={renderers.renderField}
          label="Description"
        />

        <Field
          component={renderers.renderSelectField}
          as="select"
          validate={[validations.required]}
          name="consignment_type"
          label="Consignment Type"
        >
          {consignment_type &&
            consignment_type.map((x) => (
              <option key={x.url} value={x.value}>
                {x.value}
              </option>
            ))}
        </Field>
      </ReactBootstrap.Col>
      {getFormItems(enableBulkMode)}

      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}

RepairInventoryForm = reduxForm({
  // a unique name for the form
  form: 'repair-inventory-form',
})(RepairInventoryForm)

// Decorate with connect to read form values
const selector = formValueSelector('repair-inventory-form')
RepairInventoryForm = connect((state) => {
     // can select values individually
  const partNumber = selector(state, 'part_number')


  return {
   partNumber
  }
})(RepairInventoryForm)

export default RepairInventoryForm
